module.exports = __webpack_public_path__ + "img/s660-used-car-guide-image.35a17247.jpg";